import { createToastManager } from "@autonoma/blacklight";

export const toastManager = createToastManager();
